var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 93.017,
    viewBox: "0 0 70 93.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_182-2",
    x: 4,
    y: 0,
    width: 61.86,
    height: 69.611,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951",
    transform: "translate(6437 -3993.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    transform: "translate(558.832 -83.028)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6995.83, 4077.01)",
    filter: "url(#Path_182-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182-2-2",
    "data-name": "Path 182-2",
    d: "M365.351-861.1c-.233-1.794-.234-1.954-2.157-1.942-3.638.024-7.262-.284-10.9-.293-1.378,0-2.753-.156-4.131-.214-2.988-.127-5.985-.226-8.958-.647a3.518,3.518,0,0,1-3.112-3.217c-.076-.792.178-1.707-.707-2.286-.249-.163-.087-.476-.007-.743a7.594,7.594,0,0,0,.1-4.422,6.706,6.706,0,0,1,.79-5.18,5.522,5.522,0,0,0,.7-2.05c.049-.606.113-1.15-.569-1.454a.614.614,0,0,1-.369-.547c-.111-2.186-1.785-3.832-1.987-6.037a58.153,58.153,0,0,0-.876-6.361c-.5-2.432-.813-4.906-1.093-7.376a30.253,30.253,0,0,0-1.39-5.8,10.267,10.267,0,0,1-.416-3.854c.038-.57.255-.754.864-.759,5.042-.048,10.083-.151,15.125-.219,1.935-.026,3.87,0,5.865.073a2.333,2.333,0,0,0-1.661,2.1,2.768,2.768,0,0,0,1.368,2.38c.862.7,1.667,1.476,2.91,1.424.543-.023.762.425.971.857.792,1.641,1.61,3.268,2.393,4.913a1.971,1.971,0,0,0,1.139.914,7.2,7.2,0,0,1,3.66,3.342c.035.068.063.166.121.192,1.951.891,2.41,2.983,3.61,4.475.143.178.291.412.486.481,2.317.816,2.532,2.943,3.074,4.868a6.1,6.1,0,0,1,.24,1.007A2,2,0,0,0,372-885.493c1.3.4,1.5,1.749,1.628,2.843a2.759,2.759,0,0,0,2.087,2.531c.558.185.4.419.2.748-2.076,3.44-2.674,7.435-4.134,11.108a7.006,7.006,0,0,0-.061,2.275c-.011.494-.163.811-.774.664-1.225-.3-2.461-.543-3.689-.828-1.249-.291-2.059.508-1.807,1.809a6.162,6.162,0,0,1,.242,2.726C365.649-861.442,365.68-861.23,365.351-861.1Z",
    transform: "translate(-318.24 922.51)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGa);
export default __webpack_public_path__ + "static/media/GA.9122939e20fb0c8c9b589c24f633d3d1.svg";
export { ForwardRef as ReactComponent };